import { Message } from '@docs/kd-d2c-components';
import intl from '@/internationalzation/intl';
import { initApiInterceptor } from '@src/common/axiosConfig';
import { UserInfoData, getUserApi } from '@src/services/walle';
import { getMyInfo } from '@src/services/teammate';
import { login } from '@src/utils/login';
import { create } from 'zustand';
interface UserInfoModel {
  userInfo: UserInfoData & { inV2Grayscale?: boolean };
  getUserInfo: () => void;
  getTeammateUserInfo: () => Promise<{ inV2Grayscale?: boolean }>;
  userInfoLoaded: boolean;
}
const useUserInfo = create<UserInfoModel>((set) => ({
  userInfo: {},
  userInfoLoaded: false,
  getTeammateUserInfo: async () => {
    const res = await getMyInfo({});
    if (res.status === 0 && res.data) {
      set((state) => {
        state.userInfo.inV2Grayscale = res.data?.inV2Grayscale ?? false;
        return {
          ...state,
        };
      });
      return {
        inV2Grayscale: res.data?.inV2Grayscale ?? false,
      };
    }
    return {
      inV2Grayscale: false,
    };
  },
  getUserInfo: async () => {
    const { data: userInfo, code, message } = await getUserApi({});
    if (code === 0 && userInfo) {
      set((state) => {
        state.userInfo = userInfo;
        state.userInfoLoaded = true;
        return {
          ...state,
        };
      });
    } else if (code === 401) {
      // 未登录
      // 重新登录
      login();
    } else {
      Message.error({
        duration: 2000,
        message: message || intl.t('获取用户信息失败'),
      });
    }
  },
}));

// 初始化接口拦截器
initApiInterceptor();
export const userInfoReady = Promise.all([
  useUserInfo.getState().getUserInfo(),
  useUserInfo.getState().getTeammateUserInfo(),
]).then(([userInfo, teammateUserInfo]) => {
  return {
    ...teammateUserInfo,
  };
});
export default useUserInfo;
